import { Editor, Range } from 'slate';

import onEnter from './Enter';
import onTab from './Tab';
import onBackspace from './Backspace';
import { isSelectionInList, inListOfType } from '../utils';
import type { EventHandler } from '../../../types/aha-editor';

const onKeyDown: EventHandler<KeyboardEvent> = (event, ahaEditor) => {
  const { editor } = ahaEditor;
  if (!isSelectionInList(editor)) return undefined;

  if (editor.selection && !Range.isCollapsed(editor.selection)) {
    editor.selection = Editor.unhangRange(editor, editor.selection);
  }

  switch (event.key) {
    case 'Tab':
      if (inListOfType(editor, 'dl_list')) {
        // Definition lists don't support indent/outdent. We do nothing to
        // avoid confusion since the user may be used to pressing indent in
        // a list.
        event.preventDefault();
        return true;
      } else {
        return onTab(event, ahaEditor);
      }
    case 'Enter':
      return onEnter(event, ahaEditor);
    case 'Backspace':
      return onBackspace(event, ahaEditor);
    default:
      break;
  }
};

export default onKeyDown;
